// Booking link for an affiliate. Pure functions so they can be unit tested.
// utm_source is always the ref code: commission attribution and the visit
// count match utm_sources.source against affiliates.ref_code and nothing else.

export const DEFAULT_UTM_VALUE = 'affiliate'
export const UTM_VALUE_PATTERN = /^[a-z0-9_-]{1,64}$/

// Trim and lowercase, mirroring the create-affiliate lambda.
export function normalizeUtmValue(value) {
  if (value === null || value === undefined) return ''
  return String(value).trim().toLowerCase()
}

export function isUtmValueValid(value) {
  return UTM_VALUE_PATTERN.test(normalizeUtmValue(value))
}

// bookingUrl ends with a slash (api-config BOOKING_URL). Blank medium or
// campaign fall back to the default so a preview never renders an empty param.
export function buildAffiliateLink(bookingUrl, groupCode, affiliate) {
  const source = normalizeUtmValue(affiliate && affiliate.ref_code)
  const medium = normalizeUtmValue(affiliate && affiliate.utm_medium) || DEFAULT_UTM_VALUE
  const campaign = normalizeUtmValue(affiliate && affiliate.utm_campaign) || DEFAULT_UTM_VALUE
  return `${bookingUrl}${groupCode}`
    + `?utm_source=${encodeURIComponent(source)}`
    + `&utm_medium=${encodeURIComponent(medium)}`
    + `&utm_campaign=${encodeURIComponent(campaign)}`
}
